import React, { useEffect, useState } from "react";
import { getFileUrls, peekFileUrl } from "../API/fileUrls";

/**
 * An <img> for a file stored in the database.
 *
 * Drop-in replacement for `<img src={BASE_URL + "/preview-file/" + id} />`.
 * Those URLs are no longer open, so the signed link is resolved first; several
 * images rendering together share a single request.
 *
 * While resolving, and if the file id is missing or the link cannot be
 * fetched, `fallback` is shown instead of a broken image.
 */
export default function FileImage({ fileId, fallback = null, alt = "", ...imgProps }) {
  const id = fileId ? String(fileId) : "";
  const [src, setSrc] = useState(() => (id ? peekFileUrl(id, "preview") : null));

  useEffect(() => {
    let cancelled = false;
    if (!id) {
      setSrc(null);
      return undefined;
    }
    const cached = peekFileUrl(id, "preview");
    if (cached) {
      setSrc(cached);
      return undefined;
    }
    getFileUrls([id]).then((urls) => {
      if (!cancelled) setSrc(urls[id]?.preview || null);
    });
    return () => {
      cancelled = true;
    };
  }, [id]);

  if (!src) {
    return fallback ? <img {...imgProps} alt={alt} src={fallback} /> : null;
  }
  return <img {...imgProps} alt={alt} src={src} />;
}
